module.exports = __webpack_public_path__ + "static/media/angle-left.cf4d27e8.svg";